import { isEventBus, isObservable, noAutoTerminal, autoTerminalAware, isAutoTerminal, isCallable, spySubscriptions, isValueSet, isDestroyedValue } from './value';
import { mixin } from './mix';
import { ownEffect } from './pipe';
export var State;
(function (State) {
    State[State["Initializing"] = 0] = "Initializing";
    State[State["Initialized"] = 1] = "Initialized";
    State[State["Destroying"] = 2] = "Destroying";
    State[State["Destroyed"] = 3] = "Destroyed";
})(State || (State = {}));
let _PatchingHub = undefined;
export const patch = (o) => {
    _PatchingHub.scope.$patcher.queue(ownEffect(_PatchingHub.patch, o, _PatchingHub));
    console.warn('Explicit use of patch is obsolete');
    //_PatchingHub.scope.$pipe.push(ownTask(_PatchingHub.patch, o, _PatchingHub))
};
let _ScopeKey;
const scopeKeyAware = (key, fn) => {
    const prevScopeKey = _ScopeKey;
    _ScopeKey = key;
    fn();
    _ScopeKey = prevScopeKey;
};
const createMonitoredThenable = (thenable) => {
    const monitored = thenable.then((v) => {
        mt.isDone = true;
        mt.isPending = false;
        return v;
    }, (v) => {
        mt.isFailed = true;
        mt.isPending = false;
        return v;
    });
    const mt = {
        isPending: true,
        isFailed: false,
        isDone: false,
        then: (resolve, reject) => monitored.then(resolve, reject)
    };
    return mt;
};
const isMonitoredThenable = (v) => {
    return v.then != null;
};
// export const _iterator = <T extends []|{}>(source: T) : ValueIterator<T> => {
//     if (_ScopeKey == null) {
//         console.warn('Scope key not detected')
//     }
//     return iterator(source, String(_ScopeKey))
// }
// export const _next = <T extends {}|[], K extends keyof T=keyof T>(value: Value<T>) : T[K] => {
//     if (_ScopeKey == null) {
//         console.warn('Scope key not detected')
//     }
//     return value as any
// }
// interface ReactionHelpers {
//     readonly isLast: boolean
//     readonly isFirst: boolean
// }
// class DefaultReactionHelpers implements ReactionHelpers {
//     get isLast () {
//         return isLastValue(_PatchingHub.scope[String(_ScopeKey)])
//     }
//     get isFirst () {
//         return false
//     }
// }
let _hubTotal = 0;
export const getHubsCount = () => _hubTotal;
export class Hub {
    //    _context: any
    // initialized: boolean
    // destroyed: boolean
    //    _Injectors: Injectors<any> = null
    constructor(options, context = null, initScope = null) {
        this.options = {};
        //        this.context = context
        //        this.scope = Object.assign({}, context as any)
        this._local = {};
        //        this._context = {...context}
        //let _InjectProp: string|symbol = null
        const _InjectProps = {};
        let PropState;
        (function (PropState) {
            PropState[PropState["None"] = 0] = "None";
            PropState[PropState["Initial"] = 1] = "Initial";
            PropState[PropState["Injector"] = 2] = "Injector";
            PropState[PropState["Default"] = 3] = "Default";
            PropState[PropState["Context"] = 4] = "Context";
        })(PropState || (PropState = {}));
        let _initials = null;
        // injector -> initial -> default -> context
        this.scope = new Proxy(this._local, {
            get: (target, p) => {
                if (p == '$context') {
                    return context;
                }
                //                console.log('get', p)
                let isInjected = false;
                let prop = _InjectProps[String(p)] || PropState.None;
                // const prevPropState = _InjectProps[String(p)]
                // const prevProp = target[p]
                //                if () {
                if ((p in target)) {
                    isInjected = true;
                    //                        return (target[p] && isAutoTerminal() && target[p].$isTerminal) ? target[p].$value : target[p]
                }
                // if (this.state == State.Initializing) {
                //     isInjected = false
                //     prop = PropState.None
                //     target[p] = undefined
                // }
                // if (this.options.injections && (this.options.injections as any)['$engine']) {
                //     console.log('$engine', p, isInjected, prop)
                // }
                //                }
                if (!isInjected && prop < PropState.Initial && (initScope || this.options.init)) {
                    //                    console.log('--- check initial ---', p)
                    let hasProp = false;
                    if (initScope) {
                        if (isValueSet(initScope)) {
                            hasProp = !isDestroyedValue(initScope) && initScope.$has(p) && initScope.$at(p).$value != null;
                        }
                        else if (initScope[p] != null) {
                            hasProp = true;
                        }
                    }
                    if (hasProp) {
                        _InjectProps[String(p)] = PropState.Initial;
                        target[p] = initScope[p];
                        isInjected = true;
                    }
                    else if (this.options.init) {
                        if (!_initials) {
                            _initials = this.options.init();
                        }
                        if (_initials[p] != null) {
                            _InjectProps[String(p)] = PropState.Initial;
                            target[p] = _initials[p];
                            isInjected = true;
                        }
                    }
                }
                if (!isInjected && prop < PropState.Injector && this.options.injections) {
                    const injector = this.options.injections[p];
                    if (injector !== undefined) {
                        if (typeof injector === 'function') {
                            _InjectProps[String(p)] = PropState.Injector;
                            scopeKeyAware(p, () => {
                                noAutoTerminal(() => {
                                    // const entry = injector(this.scope)
                                    // if (entry !== undefined) {
                                    //     target[p] = entry
                                    // }
                                    target[p] = injector(this.scope);
                                });
                            });
                        }
                        else if (injector != null) {
                            console.warn('Injector must be a function', p, injector);
                            return;
                        }
                        isInjected = true;
                        //                            return target[p]
                    }
                }
                if (!isInjected && prop < PropState.Default && this.options.defaults) {
                    const injector = this.options.defaults[p];
                    if (injector !== undefined) {
                        if (typeof injector === 'function') {
                            _InjectProps[String(p)] = PropState.Default;
                            scopeKeyAware(p, () => {
                                noAutoTerminal(() => {
                                    target[p] = injector(this.scope);
                                });
                            });
                        }
                        else if (injector != null) {
                            console.warn('Injector must be a function', p, injector);
                            return;
                        }
                        isInjected = true;
                        //                        return target[p]
                    }
                    // else if ((this.options.initials as any).$injectors) {
                    //     if (!_initials) {
                    //         _initials = (this.options.initials as any).$injectors()
                    //     }
                    //     if (p in _initials) {
                    //         _InjectProps[String(p)] = PropState.Default
                    //         target[p] = _initials[p]
                    //         isInjected = true
                    //     }
                    // }
                }
                // if (!isInjected && prop < PropState.Default && this.options.init) {
                //     if (!_initials) {
                //         _initials = this.options.init() || {}
                //     }
                //     if (_initials[p]) {
                //         _InjectProps[String(p)] = PropState.Default
                //         target[p] = _initials[p]
                //         isInjected = true
                //     }
                // }
                if (!isInjected && prop < PropState.Context) {
                    _InjectProps[String(p)] = PropState.Context;
                    noAutoTerminal(() => {
                        target[p] = context[p];
                    });
                    isInjected = true;
                    // if (this.state == State.Initializing) {
                    //     isInjected = false
                    //     //_InjectProps[String(p)] = PropState.None
                    // }
                }
                if (this.state == State.Initializing && (p == '$patcher' || p == '$renderer' || p == '$pipe')) {
                    const out = (target[p] && isAutoTerminal() && target[p].$isTerminal) ? target[p].$value : target[p];
                    delete target[p];
                    _InjectProps[String(p)] = PropState.None;
                    isInjected = false;
                    return out;
                }
                //                return target[p]
                return (target[p] && isAutoTerminal() && target[p].$isTerminal) ? target[p].$value : target[p];
            },
            set: (target, p, value) => {
                // if (p == 'current') {
                //     debugger
                // }
                //                console.log('set scope value', p, value, p in target)
                // FIXME заменить на инжектирование
                if (!(p in target)) {
                    target[p] = this.scope[String(p)]; // неявно инжектируем
                }
                // isObservable
                if (target[p] != null && (typeof target[p].$at === 'function')) {
                    target[p].$value = value;
                }
                else {
                    //                    console.error('Inject not an observable into scope', p, value)
                    target[p] = value;
                }
                return true;
            },
            has: (target, p) => {
                return Reflect.has(target, p) || Reflect.has(context, p) || (this.options.injections && Reflect.has(this.options.injections, p));
            },
            ownKeys: (target) => {
                const keys = Object.assign(Object.assign(Object.assign({}, context), target), this.options.injections);
                return Object.keys(keys);
            },
            getOwnPropertyDescriptor: (target, p) => {
                return Reflect.getOwnPropertyDescriptor(target, p)
                    || Reflect.getOwnPropertyDescriptor(context, p)
                    || (this.options.injections && Reflect.getOwnPropertyDescriptor(this.options.injections, p));
            },
        });
        this.subscriptions = [];
        this.handlers = [];
        this.events = {};
        this.bindings = {};
        this.joints = {};
        this.state = State.Initializing;
        // добавляем патч в очередь задач
        this.scope.$patcher.queue(ownEffect(this.patch, options, this));
        _hubTotal++;
    }
    patch(optPatch) {
        var _a, _b;
        if (this.state == State.Destroying || this.state == State.Destroyed) {
            //            console.warn('Ignore patch of destroyed object', this, optPatch)
            //            return
            throw new Error('Try to patch destroyed object');
        }
        let opts = mixin(this.options, optPatch).build(this.state == State.Initialized ? this.patchRules() : this.initRules());
        if (opts === true || opts === false) {
            throw new Error('Invalid patch option mix');
        }
        //        console.log(this.options, optPatch)
        const o = this.options = opts;
        let newSubscriptions = [];
        let newHandlers = [];
        // // Injectors
        // if (optPatch.injections) {
        //     // здесь мы должны обновлять измененные инжекторы
        //     // this._Injectors = o.injections
        //     // for (let k in o.injections) {
        //     //     this.scope[k]
        //     //     // const injector: Injector<any> = o.injections[k]
        //     //     // if (injector !== undefined) {
        //     //     //     let entry = null
        //     //     //     if (typeof injector === 'function') {
        //     //     //         entry = injector(this.scope)
        //     //     //     }
        //     //     //     else if (injector != null) {
        //     //     //         console.warn('Injector must be a function', k, injector)
        //     //     //         continue
        //     //     //     }
        //     //     //     if (this.scope[k] != entry) {
        //     //     //         // TODO здесь нужно отписываться от элемента скоупа 
        //     //     //         this.scope[k] = entry
        //     //     //     }
        //     //     // }
        //     // }
        //     // this._Injectors = null
        // }
        // Joints
        //TODO joints не должны обновляться динамически, но все равно нужно сделать обработку
        if (optPatch.joints) {
            noAutoTerminal(() => {
                for (let k in optPatch.joints) {
                    let joint = this.joints[k];
                    if (joint) {
                        console.warn('Non initial joint update', k, optPatch);
                        // удаляем старое подключение
                        if (joint.disjoint) {
                            if (typeof joint.disjoint === 'function') {
                                joint.disjoint();
                            }
                        }
                        // и старые подписки
                        if (joint.subscriptions) {
                            joint.subscriptions.forEach(sub => {
                                sub.observable.$unsubscribe(sub);
                                this.subscriptions = this.subscriptions.filter(s => s != sub);
                            });
                        }
                        // joint.disjoint = null
                        // joint.subscriptions = null
                    }
                    else {
                        // создаем новое подключение
                        joint = {};
                        this.joints[k] = joint;
                    }
                    let disjoint = null;
                    const subscriptions = spySubscriptions(() => {
                        disjoint = o.joints[k].call(this, this.scope);
                    });
                    if (disjoint && disjoint.then) {
                        disjoint = createMonitoredThenable(disjoint);
                    }
                    joint.disjoint = disjoint;
                    joint.subscriptions = subscriptions;
                    // дополняем список новых подписок для $touch
                    newSubscriptions = newSubscriptions.concat(subscriptions);
                }
            });
            // const subscriptions = spySubscriptions(() => {
            //     noAutoTerminal(() => {
            //         for (let k in optPatch.joints) {
            //             if (this.joints[k]) {
            //                 // удаляем старое подключение
            //             }
            //             // создаем новое подключение
            //             let joint = o.joints[k].call(this, this.scope)
            //             if (joint && (joint as Thenable).then) {
            //                 joint = createMonitoredThenable(joint)
            //             }
            //             this.joints.push(joint)
            //             // for (let i in o.joints[k]) {
            //             //     if (o.joints[k][i]) {
            //             //         const joint = o.joints[k][i].call(this, this.scope[k], this.scope)
            //             //         this.joints.push(joint)    
            //             //     }
            //             // }
            //         }        
            //     })
            // })
            // newSubscriptions = newSubscriptions.concat(subscriptions)
        }
        // Reactors
        if (optPatch.reactions) {
            for (let k in o.reactions) {
                if (o.reactions[k] && !this.bindings[k]) {
                    this.changeReaction(k, o.reactions, this.scope, this.bindings, newSubscriptions);
                    // const reactions = o.reactions[k]
                    // if (typeof reactions === 'function') {
                    //     this.bindings[k] = this.patchAware(reactions)//scopeKeyAware.bind(this, k, this.patchAware(o.reactions[k])) 
                    //     const entry = this.scope[k]
                    //     const binding = this.bindings[k]
                    //     if (isObservable(entry)) {
                    //         const sub = entry.$subscribe((next: any, prev: any) => {
                    //             autoTerminalAware(() => {
                    //                 scopeKeyAware(k, () => {
                    //                     // здесь скоуп должен быть доступен только для чтения
                    //                     binding(entry.$isTerminal ? next : entry, prev/*, this.scope*/)
                    //                 })    
                    //             })
                    //         })
                    //         newSubscriptions.push(sub)
                    //     }
                    //     else {
                    //         binding(entry, undefined)
                    //     }    
                    // }
                    // else if (typeof reactions === 'object') {
                    // }
                    // FIXME
                }
            }
        }
        // Events
        if (optPatch.events) {
            for (let i in o.events) {
                if (o.events[i] && !this.events[i]) {
                    this.events[i] = o.events[i]; // FIXME
                    // for (let k in this.scope) {
                    //     const bus = this.scope[k]
                    //     const callback = this.events[i]
                    //     if (isEventBus(bus) && bus.$hasEvent(i)) {
                    //         const handler = bus.$on(i, (evt: any) => {
                    //             noAutoTerminal(() => {
                    //                 callback(evt, this.scope)
                    //             })
                    //         }, this)
                    //         newHandlers.push(handler) // FIXME
                    //     }
                    // }
                    const events = o.events[i];
                    if (typeof events === 'function') {
                        if (isCallable(this.scope[i])) {
                            const bus = this.scope[i];
                            const callback = events;
                            const handler = bus.$on('done', (...args) => {
                                noAutoTerminal(() => {
                                    callback.apply(null, [args[0], this.scope]);
                                });
                            }, this);
                            newHandlers.push(handler); // FIXME
                        }
                    }
                    else if (typeof events === 'object') {
                        const bus = this.scope[i];
                        for (let k in events) {
                            // FIXME добавить регистрацию событий
                            const callback = events[k];
                            if (callback && isEventBus(bus) /*&& bus.$hasEvent(i)*/) {
                                const handler = bus.$on(k, (...args) => {
                                    noAutoTerminal(() => {
                                        callback.apply(null, [args[0], this.scope]);
                                    });
                                }, this);
                                newHandlers.push(handler); // FIXME
                            }
                        }
                    }
                }
            }
        }
        // освежаем реакции
        //        noAutoTerminal(() => {
        // if (newSubscriptions.length) {
        //     console.log('new subscriptions', newSubscriptions)
        // }
        for (let sub of newSubscriptions) {
            if (sub == null) {
                console.error('Undefined subscription');
            }
            else {
                sub.observable.$touch(sub.subscriber);
            }
        }
        //        })
        // TODO предполагается, что повторов подписок нет
        this.subscriptions = this.subscriptions.concat(newSubscriptions);
        this.handlers = this.handlers.concat(newHandlers);
        if (this.state == State.Initializing) {
            this.state = State.Initialized;
            (_b = (_a = this.events).afterInit) === null || _b === void 0 ? void 0 : _b.call(_a, this, this.scope);
        }
        // if (this.events['patch']) {
        //     this.events['patch'](this.options, this.scope)
        // }
    }
    changeReaction(k, reactions, entries, bindings, newSubscriptions) {
        const reaction = reactions[k];
        if (typeof reaction === 'function') {
            bindings[k] = this.patchAware(reaction); //scopeKeyAware.bind(this, k, this.patchAware(o.reactions[k])) 
            const entry = entries[k];
            const binding = bindings[k];
            if (isObservable(entry)) {
                const sub = entry.$subscribe((next, prev) => {
                    autoTerminalAware(() => {
                        scopeKeyAware(k, () => {
                            // здесь скоуп должен быть доступен только для чтения
                            const patchOpts = binding(entry.$isTerminal ? next : entry, prev /*, this.scope*/);
                            if (patchOpts) {
                                this.scope.$patcher.queue(ownEffect(this.patch, patchOpts, this));
                                // this.patchAware(() => {
                                //     patch(patchOpts)
                                // })()
                            }
                        });
                    });
                });
                newSubscriptions.push(sub);
            }
            else {
                const patchOpts = binding(entry, undefined);
                if (patchOpts) {
                    this.scope.$patcher.queue(ownEffect(this.patch, patchOpts, this));
                    // this.patchAware(() => {
                    //     patch(patchOpts)
                    // })()
                }
            }
        }
        else {
            for (let i in reaction) {
                this.changeReaction(i, reactions[k], entries[k], bindings[k], newSubscriptions);
            }
        }
    }
    destroy(deferred) {
        // исключаем повторное удаление
        if (this.state == State.Destroying || this.state == State.Destroyed) {
            return;
        }
        // обрабатываем хуки отключения скоупа
        let disjointPromise = null;
        const promises = [];
        for (let k in this.joints) {
            const disjoint = this.joints[k].disjoint;
            if (disjoint) {
                if (isMonitoredThenable(disjoint)) {
                    disjoint.isPending && promises.push(disjoint);
                }
                else if (typeof disjoint === 'function') {
                    const eff = disjoint();
                    if (eff && eff.then) {
                        promises.push(eff);
                    }
                }
            }
            // const subscriptions = this.joints[k].subscriptions
            // if (subscriptions) {
            //     subscriptions.forEach(sub => {
            //         sub.observable.$unsubscribe(sub)
            //     })
            // }
        }
        this.joints = {};
        if (promises.length > 0) {
            disjointPromise = Promise.all(promises);
        }
        // if (this.joints.length > 0) {
        //     const promises: Thenable[] = []
        //     for (let disjoint of this.joints) {
        //         if (disjoint) {
        //             if (isMonitoredThenable(disjoint)) {
        //                 disjoint.isPending && promises.push(disjoint)
        //             }
        //             else if (typeof disjoint === 'function') {
        //                 const eff = disjoint()
        //                 if (eff && (eff as Thenable).then) {
        //                     promises.push(eff)
        //                 }    
        //             }
        //         }
        //     }
        //     this.joints = []
        //     if (promises.length > 0) {
        //         disjointPromise = Promise.all(promises)
        //     }    
        // }
        // удаляем подписки на изменения
        for (let sub of this.subscriptions) {
            if (sub == null) {
                console.error('Undefined subscription');
            }
            else {
                sub.observable.$unsubscribe(sub);
            }
        }
        // удаляем подписки на события
        for (let h of this.handlers) {
            h.bus.$off(h);
        }
        //        this.bindings = {}
        this.events = {};
        //        this.subscriptions = []
        this.handlers = [];
        if (disjointPromise) {
            this.state = State.Destroying;
            disjointPromise.then(() => {
                // завершаем удаление, только если статус на удалении
                if (this.state == State.Destroying) {
                    deferred && deferred();
                    this.scope = null;
                    this.state = State.Destroyed;
                    console.log('Delayed destroy done');
                    _hubTotal--;
                }
            }, (err) => {
                console.log('Delayed destroy fail', err);
            });
        }
        else {
            deferred && deferred();
            this.scope = null;
            this.state = State.Destroyed;
            _hubTotal--;
        }
        // // отложенное удаление
        // if (promise) {
        //     this.state = State.Destroying
        //     promise.then(() => {
        //         // продолжаем удаление, если оно не отменено
        //         if (this.state == State.Destroying) {
        //             //this.state = State.Initialized // ?
        //             this.destroy()
        //             //this.scope.$engine.immediate(this) // ?
        //         }
        //      }, (err) => {
        //         console.log('Delayed destroy fail', err)
        //      })
        //     return
        // }
        // if (disjointPromise) {
        //     this.state = State.Destroying
        //     disjointPromise.then(() => {
        //         // продолжаем удаление, если оно не отменено
        //         // if (this.state == State.Destroying) {
        //         //     //this.state = State.Initialized // ?
        //         //     this.destroy()
        //         //     //this.scope.$engine.immediate(this) // ?
        //         // }
        //      }, (err) => {
        //         console.log('Delayed destroy fail', err)
        //      })            
        // }
        // else {
        //     this.state = State.Destroyed
        // }
    }
    patchAware(callback) {
        return (...args) => {
            const prevPatchingTarget = _PatchingHub;
            _PatchingHub = this;
            const result = callback.apply(this, args);
            _PatchingHub = prevPatchingTarget;
            return result;
        };
    }
    // emit (name: string, event: any) {
    //     this.events[name](event, this.scope)
    // }
    initRules() {
        return {};
    }
    patchRules() {
        return {};
    }
    reinit(nextOpts) {
        // TODO здесь должна происходить очистка компонента
        // предполагается, что сброс может происходить при удалении
        // приводим к такому же состоянию, что и в конструкторе, т.е. этапу инициализации
        //         for (let joint of this.joints) {
        //             if (joint != null) {
        //                 if (isMonitoredThenable(joint)) {
        //                     console.warn('Ignore async disjoint')
        //                 }
        //                 else if (typeof joint === 'function') {
        //                     joint()
        //                 }
        //             }
        //         }
        //         // удаляем подписки на изменения
        //         for (let sub of this.subscriptions) {
        //             if (sub == null) {
        //                 console.error('Undefined subscription')
        //             }
        //             else {
        //                 sub.observable.$unsubscribe(sub)
        //             }
        //         }
        //         // удаляем подписки на события
        //         for (let h of this.handlers) {
        //             h.bus.$off(h)
        //         }
        // //        this.bindings = {}
        //         this.events = {}
        // //        this.subscriptions = []
        //         this.handlers = []
        //         this.joints = []
        this.state = State.Initializing;
        console.warn('reinitialize', nextOpts, this.options);
        if (nextOpts == null) {
            nextOpts = this.options;
        }
        this.options = {};
        this.patch(nextOpts);
    }
}
